// extracted by mini-css-extract-plugin
export var bonus = "style-module--bonus--91693";
export var content = "style-module--content--b1c2a";
export var dates = "style-module--dates--abe35";
export var info = "style-module--info--95239";
export var screen1 = "style-module--screen1--78de3";
export var sub = "style-module--sub--b5d4b";